import * as React from 'react'

function SvgIconSoundMax(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="sound-max" aria-labelledby="t-sound-max d-sound-max">
        <title id="t-sound-max">{'Maximum sound'}</title>
        <desc id="d-sound-max">{'A loudspeaker with three sound waves'}</desc>
        <path d="M14 7v18l-6-6H1v-6h7l6-6m0-1c-.3 0-.5.1-.7.3L7.6 12H1c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6.6l5.7 5.7c.2.2.4.3.7.3.1 0 .3 0 .4-.1.4-.2.6-.5.6-.9V7c0-.4-.2-.8-.6-.9-.1-.1-.3-.1-.4-.1zm13 21.5c-.1 0-.3 0-.4-.1a.485.485 0 010-.7C29.4 23.8 31 20 31 16s-1.6-7.8-4.4-10.6a.485.485 0 010-.7c.2-.2.5-.2.7 0 3 3 4.7 7 4.7 11.3s-1.7 8.3-4.7 11.3c-.1.1-.2.2-.3.2z" />
        <path d="M23.4 23.9c-.104 0-.301 0-.4-.104-.2-.196-.2-.5 0-.696 3.9-3.9 3.9-10.2 0-14.1-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0 4.3 4.3 4.3 11.3 0 15.601h-.3V23.9zm-3.5-3.5c-.104 0-.301 0-.4-.104-.2-.196-.2-.5 0-.696.9-.9 1.5-2.2 1.5-3.5s-.5-2.6-1.5-3.5c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0 1.1 1.1 1.8 2.6 1.8 4.2s-.6 3.1-1.8 4.2c-.1 0-.2.1-.3.1z" />
      </g>
    </svg>
  )
}

export default SvgIconSoundMax
